export default {"src":"/_next/static/media/logo.90025ac0.svg","height":88,"width":394,"blurWidth":0,"blurHeight":0};